export default __webpack_public_path__ + "static/process-3-ee3bb8ab1409e58393f8cf6138ff4e5a.jpeg";